module.exports = __webpack_public_path__ + "img/PM_A01_back_el.642ddab5.png";